import { render, staticRenderFns } from "./WorkflowInstanceList.vue?vue&type=template&id=0122b335"
import script from "./WorkflowInstanceList.vue?vue&type=script&lang=js"
export * from "./WorkflowInstanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports